// LineupCountBar — a YouTube-style "Queue" bar that slides up from the
// bottom whenever a movie/video is added to My Lineup, keeping a running
// count. Tap it to jump to /my-lineup. It listens to the global
// "hw:lineup-changed" event so it works no matter which 3-dot menu added
// the item. Auto-hides after a few seconds; tapping keeps it useful.
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Queue, CaretRight } from "@phosphor-icons/react";

const EVENT = "hw:lineup-changed";

export default function LineupCountBar() {
  const navigate = useNavigate();
  const [state, setState] = useState(null); // { count, title }
  const hideTimer = useRef(null);

  useEffect(() => {
    const onChange = (e) => {
      const d = e.detail || {};
      if (!d.queued) return;                 // only on ADD, not removal
      if (typeof d.count !== "number") return;
      setState({ count: d.count, title: d.title || "" });
      clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setState(null), 6000);
    };
    window.addEventListener(EVENT, onChange);
    return () => { window.removeEventListener(EVENT, onChange); clearTimeout(hideTimer.current); };
  }, []);

  if (!state) return null;

  return (
    <button
      onClick={() => { setState(null); navigate("/my-lineup"); }}
      data-testid="lineup-count-bar"
      className="fixed left-1/2 -translate-x-1/2 bottom-24 md:bottom-6 z-[60] max-w-[92vw] flex items-center gap-3 pl-3 pr-2.5 h-12 rounded-full bg-ink text-cream shadow-2xl border border-white/10 animate-fade-up"
    >
      <span className="inline-flex items-center gap-1.5 px-2.5 h-7 rounded-full bg-terracotta text-cream text-xs font-bold tracking-wide shrink-0" data-testid="lineup-count-badge">
        <Queue size={13} weight="bold" /> Queue {state.count}
      </span>
      <span className="min-w-0 text-left">
        <span className="block text-[10px] uppercase tracking-wider text-cream/60 leading-none">Added to lineup</span>
        <span className="block text-sm font-semibold truncate max-w-[44vw] md:max-w-xs">{state.title || "New video"}</span>
      </span>
      <span className="inline-flex items-center gap-0.5 text-cream/80 text-xs font-semibold shrink-0">
        Open <CaretRight size={13} weight="bold" />
      </span>
    </button>
  );
}
